
module.exports = require('./dist/post-robot');
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/post-robot/index.js
// module id = SRWI
// module chunks = 1